import { Column } from "../../../Components/Tables/Table";
import { header } from "../../../Shared/Cards/Card.type";

export class BasicInfo {
  public code: string;
  public name: string;
  public contact_phone: string;
  public contact_email: string;
  public address_line_1: string;
  public address_line_2: string;
  public city: string;
  public state_province: string;
  public country: string;
  public postal_code: string;
  public is_active: boolean;
  public is_used_for_packslip: boolean;
  public logo: any;

  constructor() {
    this.code = "";
    this.name = "";
    this.contact_phone = "";
    this.contact_email = "";
    this.address_line_1 = "";
    this.address_line_2 = "";
    this.city = "";
    this.state_province = "";
    this.postal_code = "";
    this.country = "";
    this.is_active = true;
    this.is_used_for_packslip = true;
    this.logo = {};
  }
}

export interface BasicInfo {
  code: string;
  name: string;
  contact_phone: string;
  contact_email: string;
  address_line_1: string;
  address_line_2: string;
  city: string;
  state_province: string;
  country: string;
  postal_code: string;
  is_active: boolean;
  is_used_for_packslip: boolean;
  logo: any;
}

export class Mapping {
  public clientWarehouse: { label: string; value: string }[];
  public clientWorkflow: { category: string; key: string }[];

  constructor() {
    this.clientWarehouse = [];
    this.clientWorkflow = [];
  }
}

export class Accessorial {
  public accBillCode: string;
  public selectType: string;
  public rate: string;
  public arn_receipt: boolean;
  public order_shipment: boolean;
  public claType: string;
  public billMin: string;

  constructor() {
    this.accBillCode = "";
    this.selectType = "";
    this.rate = "";
    this.arn_receipt = false;
    this.order_shipment = false;
    this.claType = "";
    this.billMin = "";
  }
}
export class PackageType {
  public packCode: string;
  public desc: string;
  public length: string;
  public lengthMeasurement: string;
  public width: string;
  public widthMeasurement: string;
  public height: string;
  public heightMeasurement: string;
  public packageVolume: string;
  constructor() {
    this.packCode = "";
    this.desc = "";
    this.length = "";
    this.lengthMeasurement = "";
    this.width = "";
    this.widthMeasurement = "";
    this.height = "";
    this.heightMeasurement = "";
    this.packageVolume = "";
  }
}
export class ProductivityInbound {
  public in_serialNumber: number;
  public in_entity: string;
  public in_goalType: string;
  public in_interval: string;
  public in_quantity: string;
  constructor() {
    this.in_serialNumber = 0;
    this.in_entity = "";
    this.in_goalType = "";
    this.in_interval = "";
    this.in_quantity = "";
    this.in_entity = "";
  }
}
export class ProductivityOutbound {
  public out_serialNumber: number;
  public out_entity: string;
  public out_goalType: string;
  public out_interval: string;
  public out_quantity: string;
  constructor() {
    this.out_serialNumber = 0;
    this.out_entity = "";
    this.out_goalType = "";
    this.out_interval = "";
    this.out_quantity = "";
    this.out_entity = "";
  }
}
export class Productivity {
  public inBound: ProductivityInbound[];
  public outBound: ProductivityOutbound[];
  constructor() {
    this.inBound = [];
    this.outBound = [];
  }
}
export class Setting {
  public ASNFieldReference1: string;
  public ASNFieldReference2: string;
  public OutboundFieldReference1: string;
  public OutboundFieldReference2: string;
  public OutboundFieldReference3: string;
  public OutboundFieldReference4: string;
  public purchaseOrder: boolean;
  public allowBackorder: boolean;
  public shipmentEmails: boolean;
  public allowPositiveAdjustments: boolean;
  public unitOfMeasure:boolean;
  constructor() {
    this.ASNFieldReference1 = "";
    this.ASNFieldReference2 = "";
    this.OutboundFieldReference1 = "";
    this.OutboundFieldReference2 = "";
    this.OutboundFieldReference3 = "";
    this.OutboundFieldReference4 = "";

    this.purchaseOrder = false;
    this.allowBackorder = false;
    this.shipmentEmails = false;
    this.allowPositiveAdjustments = false;
    this.unitOfMeasure=false;
  }
}

export interface ClientData {
  basicInfo: BasicInfo;
  mapping: Mapping;
}
export const Client: ClientData = {
  basicInfo: new BasicInfo(),
  mapping: new Mapping(),
};
export interface Client {
  id: number;
  code: string;
  name: string;
  city: string | null;
  state_province: string | null;
  logo_url: string | null;
  is_active: number | boolean;
}
export class attachments {
  public original_name: string;
  public description: string;
  public content: string;
  constructor() {
      this.original_name = "";
      this.content = "";
      this.description = "";
  }
}
export interface ClientRequest{
  code: string;
  name: string;
  address_line_1: string;
  address_line_2: string;
  city: string;
  state_province: string;
  postal_code: string;
  country: any;
  contact_phone: string;
  contact_email: string;
  is_active: boolean;
  is_used_for_packslip: boolean;
  logo?: any;
}

export interface clientlistProps {
  pageName: string;
  columns: Column[];
  addUrl: string;
  listUrl: string;
  gridUrl: string;
  viewtype: string;
  headers: header[];
  getClientDtls: any;
  search_columns: any;
  db_columns: any[];
  handleToggleChange?: (item:any,status: any) => void;
  update_status_url?:string
  statusData: any
  onDataChange?: (data: any) => void;
  setStatusData?: React.Dispatch<React.SetStateAction<null>>;
  data: any;
  refreshTrigger?: number;
}